import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Block,
  Button,
  List,
  ListItem,
  AccordionContent,
  BlockTitle,
} from "framework7-react";
import {
  consumeApi,
  numberFormat,
  setLiteral,
  removeHtmlTags,
  sentenceFormat,
  obtenerTextoAntesDeHTML,
} from "../../../js/helpers";

const formatCurrency = (value) => {
  if (isNaN(value) || value === null) return "0.00";
  return (
    "$ " +
    new Intl.NumberFormat("es-ES", { minimumFractionDigits: 2 }).format(value)
  );
};

const ContractList = ({
  contracts = [],
  onDetailClick,
  title,
  id,
  lsLiterales,
}) => {
  const [dispo, setDispo] = useState([]);
  const [balance, setBalance] = useState("0");

  useEffect(() => {
    const renderDispo = (lsContracts) => {
      const filteredContracts = lsContracts.filter(
        (contract) =>
          contract.contractType == 3 ||
          contract.contractType == 2 ||
          (contract.contractType == 1 &&
            contract.management_product === "LINEA REVOLVING")
      );

      if (filteredContracts.length > 0) {
        const groupedContracts = filteredContracts.reduce(
          (groups, contract) => {
            const groupKey = contract.contractCode.substring(0, 27);
            if (!groups[groupKey]) {
              groups[groupKey] = [];
            }

            // Verificar si ya se agregó el contrato antes de hacer unshift
            const alreadyAdded = groups[groupKey].some(
              (element) =>
                element.contractType == 1 &&
                element.management_product === "LINEA REVOLVING"
            );

            if (
              !alreadyAdded &&
              contract.contractType == 1 &&
              contract.management_product === "LINEA REVOLVING"
            ) {
              groups[groupKey].unshift(contract);
            } else {
              groups[groupKey].push(contract);
            }

            return groups;
          },
          {}
        );

        const groupedContractsArray = Object.values(groupedContracts);
        setDispo(groupedContractsArray);
      }
    };

    renderDispo(contracts);
  }, [contracts]);

  const renderDisposiciones = (list) => {
    if (list.length > 0) {
      return list.map((element) => {
        if (element.length > 1) {
          return (
            <div
              className="contenedorExtra marg1"
              id="dispo"
              key={element[0].contractId}
            >
              <List className="list" mediaList outline inset>
                <ListItem
                  id="liCreditType"
                  accordionItem
                  title={
                    <span className="smaller">
                      {removeHtmlTags(setLiteral(lsLiterales, 102026)) +
                        ":" +
                        " " +
                        element[0].contractCode}
                    </span>
                  }
                  subtitle={
                    <Row>
                      <span className="smaller">Crédito rotativo</span>

                      <span className="smaller">
                        {renderBalance(
                          element[0].applicationId,
                          element[0].company
                        )}
                      </span>
                    </Row>
                  }
                >
                  <AccordionContent>
                    {element.slice(1).map((item) => (
                      <ListItem
                        className="smaller rev"
                        key={item.contractId}
                        title={`Disposición # ${item.contractCode.substring(
                          28
                        )}`}
                        onClick={(e) => onDetailClick(e, item)}
                        subtitle={
                          <Row>
                            <span className="smaller">
                              {numberFormat(
                                `Monto financiado: $${item.amount}`
                              )}
                            </span>

                            <span className="smaller">
                              {"Fecha Disposición " + item.creation_date}
                            </span>
                          </Row>
                        }
                        after={<span className="details-link">DETALLES ›</span>}
                      />
                    ))}
                  </AccordionContent>
                </ListItem>
              </List>
            </div>
          );
        } else {
          return (
            <div
              className="contenedorExtra marg1"
              id="dispo"
              key={element[0].contractId}
            >
              <BlockTitle>
                <a className="bold large">{element[0].contractCode}</a>
                <h5 className="light">Crédito rotativo sin disposiciones</h5>
              </BlockTitle>
            </div>
          );
        }
      });
    }
    return null;
  };

  const renderBalance = (application_id, company) => {
    CreditLineGetById(application_id, company);

    return (
      <div>
        <span className="smaller">
          Límite disponible {formatCurrency(balance)}
        </span>
      </div>
    );
  };

  //#region CallApi
  const CreditLineGetById = async (application_id, company) => {
    const params = JSON.stringify({
      language_id: "C",
      user_id: "BATCH",
      company: company,
      access_level: "2",
      application_id: application_id,
      json: "",
    });

    const method = "/integration/CreditLine/CreditLineGetById";
    const creditLineGetById = await consumeApi("POST", method, params);

    if (!String(creditLineGetById).includes("error")) {
      setBalance(creditLineGetById.balance_amount);
    } else {
    }
  };
  //#endregion CallApi

  return (
    <div id={id || ""}>
      <Row>
        <Col
          id="titlEC"
          className="generalTitl small left2"
          width="100"
          small="100"
          xsmall="100"
          medium="25"
          large="25"
          xlarge="25"
        >
          {title || setLiteral(lsLiterales, 102143)}
        </Col>
      </Row>
      <br />
      <br />
      {contracts.length > 0 ? (
        contracts.map((contract) => {
          if (
            contract.stateId == 2 &&
            contract.contractType != 3 &&
            contract.management_product != "LINEA REVOLVING"
          ) {
            return (
              <div
                key={contract.contractId}
                className="contenedorPrincipal marg1"
              >
                <Row className="contracts2">
                  <Col width="5">
                    <br />
                  </Col>
                  <Col
                    className="bold smaller "
                    id="contName1"
                    width="100"
                    xlarge="70"
                    large="70"
                    medium="70"
                    small="70"
                    xsmall="70"
                  >
                    <a>
                      {removeHtmlTags(setLiteral(lsLiterales, 102026)) +
                        ":" +
                        " " +
                        contract.contractCode}
                    </a>
                    <br />
                    <span id="CreditTypePersonal" className="typeC">
                      Crédito personal
                    </span>
                  </Col>

                  <Col
                    width="100"
                    large="25"
                    xlarge="25"
                    medium="25"
                    small="40"
                    xsmall="40"
                    className="contract-action"
                  >
                    <Button
                      id="btnDetails"
                      className="Cdetails alignerCenter larger light"
                      onClick={(e) => onDetailClick(e, contract)}
                    >
                      {sentenceFormat(setLiteral(lsLiterales, 102142))}
                      {" >>"}
                    </Button>
                  </Col>
                </Row>

                <Row className="subtitle">
                  <Col
                    width="100"
                    xlarge="25"
                    large="25"
                    medium="25"
                    xsmall="50"
                    small="50"
                    className="center"
                  >
                    <div className="subtitulos small">
                      {removeHtmlTags(setLiteral(lsLiterales, 102034))}
                    </div>
                    <a className="data1 smaller bold">{`$${numberFormat(
                      contract.amount
                    )}`}</a>
                  </Col>
                  <Col
                    width="100"
                    xlarge="25"
                    large="25"
                    medium="25"
                    xsmall="50"
                    small="50"
                    className="center"
                  >
                    <div className="subtitulos small">
                      {removeHtmlTags(setLiteral(lsLiterales, 102031))}
                    </div>
                    <a className="data1 smaller bold">{contract.startDate}</a>
                  </Col>
                  <Col
                    width="100"
                    xlarge="25"
                    large="25"
                    medium="25"
                    xsmall="50"
                    small="50"
                    className="center"
                  >
                    <div className="subtitulos small">
                      {removeHtmlTags(setLiteral(lsLiterales, 102028))}
                    </div>
                    <a className="data1 smaller bold">{`${contract.term} ${contract.periodicity}`}</a>
                  </Col>
                  <Col
                    width="100"
                    xlarge="25"
                    large="25"
                    medium="25"
                    xsmall="50"
                    small="50"
                    className="center"
                  >
                    <div className="subtitulos small">
                      {setLiteral(lsLiterales, 102055)}
                    </div>
                    <a className="data1 smaller bold">{contract.state}</a>
                  </Col>
                </Row>
              </div>
            );
          }
          return null;
        })
      ) : (
        <Block className="no-contracts">No hay contratos disponibles.</Block>
      )}

      {renderDisposiciones(dispo)}
    </div>
  );
};

export default ContractList;
